import { useState } from 'react';
import './CashModal.css';

export default function CashModal({ balance, onSubmit, onClose }) {
  const [mode, setMode] = useState('deposit');
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const val = parseFloat(amount);
    if (!val || val <= 0) { setError('Enter a valid amount'); return; }
    if (mode === 'withdraw' && val > balance) { setError('Insufficient funds'); return; }

    setLoading(true);
    const result = await onSubmit(mode, val);
    setLoading(false);
    if (result?.error) { setError(result.error); return; }
    onClose();
  };

  return (
    <div className="cash-modal-overlay" onClick={onClose}>
      <div className="cash-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cash-modal-header">
          <h3>Manage Cash</h3>
          <button className="cash-modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="cash-modal-balance">
          <span className="cash-modal-label">Available Cash</span>
          <span className="cash-modal-value">${balance.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
        </div>

        <div className="cash-modal-tabs">
          <button className={mode === 'deposit' ? 'active' : ''} onClick={() => { setMode('deposit'); setError(''); }}>
            Deposit
          </button>
          <button className={mode === 'withdraw' ? 'active' : ''} onClick={() => { setMode('withdraw'); setError(''); }}>
            Withdraw
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="cash-input-group">
            <span className="cash-input-prefix">$</span>
            <input
              type="number"
              step="0.01"
              min="0"
              placeholder="0.00"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              autoFocus
            />
          </div>

          <div className="cash-quick-amounts">
            {[100, 500, 1000, 5000].map((v) => (
              <button type="button" key={v} onClick={() => setAmount(String(v))}>
                ${v.toLocaleString()}
              </button>
            ))}
          </div>

          {error && <p className="cash-error">{error}</p>}

          <button type="submit" className={`cash-submit ${mode}`} disabled={loading}>
            {loading ? 'Processing...' : mode === 'deposit' ? 'Deposit' : 'Withdraw'}
          </button>
        </form>
      </div>
    </div>
  );
}
